export default __webpack_public_path__ + "static/printing-2d0c5cac1ee9dcb0f498dcb84f98af70.gif";